import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { LoginSettingsFacade } from '@lyceo/homi/login/data-access';
import {
  ButtonComponent,
  ContentComponent,
  SingleCardLayoutComponent,
} from '@lyceo/shared/ui';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  FormFieldComponent,
  FormLabelDirective,
  InputDirective,
} from '@lyceo/shared/ui-forms';
import {
  FieldTree,
  form,
  FormField,
  required,
  submit,
} from '@angular/forms/signals';
import { LogoComponent } from '@lyceo/homi/shared/ui';

interface ChooseWebsiteForm {
  website: string;
}

@Component({
  selector: 'lib-homi-login-choose-website',
  imports: [
    ButtonComponent,
    ContentComponent,
    SingleCardLayoutComponent,
    TranslocoDirective,
    FormFieldComponent,
    FormLabelDirective,
    InputDirective,
    FormField,
    LogoComponent,
  ],
  templateUrl: './choose-website-page.component.html',
  styleUrl: './choose-website-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseWebsitePageComponent {
  private readonly loginSettingsFacade: LoginSettingsFacade =
    inject(LoginSettingsFacade);

  protected readonly settingsLoading: Signal<boolean> =
    this.loginSettingsFacade.settingsLoading;

  private readonly formModel: WritableSignal<ChooseWebsiteForm> = signal({
    website: '',
  });

  protected form: FieldTree<ChooseWebsiteForm> = form(
    this.formModel,
    (schemaPath) => {
      required(schemaPath.website);
    },
  );

  protected submit(event: Event): void {
    event.preventDefault();

    submit(this.form, async () => {
      this.loginSettingsFacade.websiteChosen(
        this.form.website().value().trim().toLowerCase(),
      );
    });
  }
}
